import { getVmModal } from "@/js/vue/modal/plugin";
import { registerClickHandler } from "@/js/utils/eventDelegation";

/**
 * モーダルクリックハンドラを登録
 *
 * 統一されたイベント委譲システムを使用して
 * [data-modal] 属性を持つ要素のクリックを処理
 */
export function registerModalHandler() {
    registerClickHandler({
        selector: '[data-modal]',
        priority: 5, // スクロール(10)より低い優先度
        callback: async (el, event) => {
            event.preventDefault();

            const modal = getVmModal()
            if (!modal) return

            // data-vars-* から vars を生成
            const vars = {}
            for (const key in el.dataset) {
                if (key.startsWith('vars')) {
                    // varsTitle → title に変換
                    const name = key.replace(/^vars/, '');
                    const normalized = name.charAt(0).toLowerCase() + name.slice(1);
                    vars[normalized] = el.dataset[key];
                }
            }

            const result = await modal.open({
                vars: { ...vars },
                tmpl: el.dataset.tmpl,
                type: el.dataset.type,
                close_only_by_btns: el.dataset.close_only_by_btns === 'true'
            })
            console.log(result);
        },
    });
}

